var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgErrorBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.9 64.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-50.373 0-91.351 40.981-91.351 91.355 0 50.37 40.978 91.354 91.351 91.354s91.354-40.984 91.354-91.354c0-50.374-40.981-91.355-91.354-91.355m0 197.52c-58.542 0-106.16-47.627-106.16-106.17 0-58.544 47.623-106.17 106.16-106.17s106.17 47.624 106.17 106.17c0 58.541-47.626 106.17-106.17 106.17"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.99 126.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-11.994c-0.818 0-1.481-0.664-1.481-1.481v-11.997c0-0.818 0.663-1.481 1.481-1.481h11.994c0.817 0 1.481 0.663 1.481 1.481v11.997c0 0.817-0.664 1.481-1.481 1.481"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.99 200.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-11.994c-0.818 0-1.481-0.664-1.481-1.481v-59.321c0-0.821 0.663-1.482 1.481-1.482h11.994c0.817 0 1.481 0.661 1.481 1.482v59.321c0 0.817-0.664 1.481-1.481 1.481"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBlkRgb);
export default __webpack_public_path__ + "static/media/Error_BLK_RGB.33b782a19350251844ff10e00892a831.svg";
export { ForwardRef as ReactComponent };